import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { SizeSetsPage } from '@/features/dictionary';

export const Route = createFileRoute('/_authed/_active/org/catalog-setup/size-sets/new')({
  staticData: { crumb: 'sizeSets:new' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'attributes.write');
  },
  component: NewSizeSetRoute,
});

function NewSizeSetRoute() {
  return <SizeSetsPage view="new" />;
}
